import { action } from 'satcheljs';

const onFindEmailFromSenderClicked = action(
    'onFindEmailFromSenderClicked',
    (senderName: string, senderEmail: string) => ({
        senderName,
        senderEmail,
    })
);

export default onFindEmailFromSenderClicked;
